import React from 'react'

//* HOC's
import { withUIContext } from 'context'

//* Helpers
import { changeWidth } from 'helpers/_gsapFunctions'

//* Style
import LineStyle from './style'

const Line = ({ color, className }) => {
    return (
        <LineStyle className={`${color} ${className || ''}`}>
            <div className='line'>
                <div className='animLine'></div>
            </div>
        </LineStyle>
    )
}

export default withUIContext(Line, ['winWidth'])
